export const iconFontAwesomeReligionPeace = (
	<i className="fa-solid fa-peace"></i>
);
